import React, { useEffect, useState } from 'react';
import { IoChevronBack } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../../../../routes/RoutesURL';
import { RootState } from '../../../../../store/rootReducer';
import HSButton from '../../../../common/Button';
import { ONBOARDING_PATH } from '../../Onbording';

type Props = {
    preferencesIndex: number;
    setPreferencesIndex: (f: number) => void;
    isMobile?: boolean;
};

const OnboardingBack: React.FC<Props> = ({ preferencesIndex, setPreferencesIndex, isMobile }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [currentPath, setCurrentPath] = useState('');
    const investorType = useSelector((state: RootState) => state.user.investor?.investorType);

    /**Get current Path */
    useEffect(() => {
        setCurrentPath(location.pathname);
    }, [location]);

    const onClickBackBtn = () => {
        if (currentPath === `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.ACCREDITATION}`) {
            navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.BASIC_PROFILE}`);
        }
        if (currentPath === `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.INVESTOR_PROFILE}`) {
            navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.ACCREDITATION}`);
        }

        if (currentPath === `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.NDA}`) {
            navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.INVESTOR_PROFILE}`);
        }

        if (currentPath === `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.INVESTMENT_PREFERENCES}`) {
            if (preferencesIndex === 1) {
                navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.NDA}`);
            }

            if (preferencesIndex > 1) {
                setPreferencesIndex(preferencesIndex - 1);
            }
        }

        if (currentPath === `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`) {
            if (investorType !== 'Institutional') {
                navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.ACCREDITED_INVESTOR}`);
            } else {
                navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.INVESTMENT_PREFERENCES}`);
            }
        }

        if (currentPath === `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.ACCREDITED_INVESTOR}`) {
            navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.INVESTMENT_PREFERENCES}`);
        }
    };

    if (currentPath === `${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.BASIC_PROFILE}`) {
        return <div className="h-8" />;
    }

    return (
        <HSButton
            type="link"
            title="Back"
            className="uppercase pl-0 text-base"
            style={{ color: isMobile ? '#FFFFFF' : '#1B3E8C' }}
            onClick={onClickBackBtn}
            icon={<IoChevronBack />}
        />
    );
};

export default OnboardingBack;
